"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listProperty = void 0;
const split_string_1 = require("../utils/split-string");
function getPropertyAsListWithDefault(dict, key, defaultValue) {
    const value = dict[key];
    if (value == null) {
        return defaultValue;
    }
    let result = (0, split_string_1.splitString)(value, ', \t\r\n');
    if (result === null) {
        return defaultValue;
    }
    if (result.length === 0) {
        result = defaultValue;
    }
    return result;
}
function listProperty(property, config = { required: false }) {
    return (dict) => {
        const value = getPropertyAsListWithDefault(dict, property, []);
        if (value.length === 0) {
            if (config.required === true) {
                throw new Error(`Missing required property ${property}`);
            }
            else {
                return config.defaultValue;
            }
        }
        return value;
    };
}
exports.listProperty = listProperty;
//# sourceMappingURL=list-property.js.map